import { useMemo } from 'react';

import {
   createDynamicColumnsWidth,
   InteractiveTable,
   InteractiveTableColumnConfiguration,
} from '@dreryk/react-components';

import { translationKeys } from '../../translations';

import { DiagnosisTableBean } from './VisitDocumentsDiagnosesForm.types';

export const useVisitDocumentsDiagnosesInteractiveTableColumnsConfiguration = (): InteractiveTableColumnConfiguration<DiagnosisTableBean>[] => {
   return useMemo(() => {
      const columnWidths = createDynamicColumnsWidth({
         code: '76px',
         name: '100%',
         options: '40px',
      });

      return [
         {
            name: 'code',
            label: translationKeys.ICD10,
            width: columnWidths.code,
            renderer: ({ bean, index }) => (
               <InteractiveTable.TextViewCell testId={'code'} name={'code'} index={index} defaultValue={bean.code} />
            ),
         },
         {
            name: 'name',
            label: translationKeys.name,
            width: columnWidths.name,
            renderer: ({ bean, index }) => (
               <InteractiveTable.TextViewCell testId={'name'} name={'name'} index={index} defaultValue={bean.name} />
            ),
         },
         {
            name: 'options',
            width: columnWidths.options,
            renderer: ({ index }) => <InteractiveTable.DeleteRowCell index={index} />,
         },
      ];
   }, []);
};
